var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcomeMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 683,
    viewBox: "0 0 340 683",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.9441 363.975C154.055 353.653 268.179 346.07 317.267 343.125L317.267 349.037C207.112 352.281 119.616 360.676 90.9441 363.975Z",
    fill: "#F2F6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320 359L323.511 349.511L333 346L323.511 342.489L320 333L316.489 342.489L307 346L316.489 349.511L320 359Z",
    fill: "#225AEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123 433L120.299 440.664L113 443.5L120.299 446.336L123 454L125.701 446.336L133 443.5L125.701 440.664L123 433Z",
    fill: "#F2F6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 365L7.29909 372.664L0 375.5L7.29909 378.336L10 386L12.7009 378.336L20 375.5L12.7009 372.664L10 365Z",
    fill: "#F2F6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144 559L141.299 566.299L134 569L141.299 571.701L144 579L146.701 571.701L154 569L146.701 566.299L144 559Z",
    fill: "#F2F6FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M331.5 530L329.204 536.204L323 538.5L329.204 540.796L331.5 547L333.796 540.796L340 538.5L333.796 536.204L331.5 530Z",
    fill: "#F2F6FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59 644L56.5692 650.569L50 653L56.5692 655.431L59 662L61.4308 655.431L68 653L61.4308 650.569L59 644Z",
    fill: "#F2F6FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M249.5 650L247.204 656.204L241 658.5L247.204 660.796L249.5 667L251.796 660.796L258 658.5L251.796 656.204L249.5 650Z",
    fill: "#F2F6FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M327 154L328.621 158.379L333 160L328.621 161.621L327 166L325.379 161.621L321 160L325.379 158.379L327 154Z",
    fill: "#F2F6FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20 206L18.3795 210.379L14 212L18.3795 213.621L20 218L21.6205 213.621L26 212L21.6205 210.379L20 206Z",
    fill: "#F2F6FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M251 112L249.379 116.379L245 118L249.379 119.621L251 124L252.621 119.621L257 118L252.621 116.379L251 112Z",
    fill: "#F2F6FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 27L103.474 32.8393L98 35L103.474 37.1607L105.5 43L107.526 37.1607L113 35L107.526 32.8393L105.5 27Z",
    fill: "#F2F6FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M256.5 235L254.474 240.839L249 243L254.474 245.161L256.5 251L258.526 245.161L264 243L258.526 240.839L256.5 235Z",
    fill: "#F2F6FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 0L292.204 6.56918L286 9L292.204 11.4308L294.5 18L296.796 11.4308L303 9L296.796 6.56918L294.5 0Z",
    fill: "#F2F6FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 166L145.204 172.569L139 175L145.204 177.431L147.5 184L149.796 177.431L156 175L149.796 172.569L147.5 166Z",
    fill: "#F2F6FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M204 28L199.949 38.9486L189 43L199.949 47.0514L204 58L208.051 47.0514L219 43L208.051 38.9486L204 28Z",
    fill: "#F2F6FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97L40.9486 107.949L30 112L40.9486 116.051L45 127L49.0514 116.051L60 112L49.0514 107.949L45 97Z",
    fill: "#F2F6FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M107 257L105.379 252.621L101 251L105.379 249.379L107 245L108.621 249.379L113 251L108.621 252.621L107 257Z",
    fill: "#F2F6FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 18L33.7958 11.7958L40 9.5L33.7958 7.20423L31.5 1L29.2042 7.20423L23 9.5L29.2042 11.7958L31.5 18Z",
    fill: "#F2F6FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M241 535L242.621 530.621L247 529L242.621 527.379L241 523L239.379 527.379L235 529L239.379 530.621L241 535Z",
    fill: "#F2F6FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M138 683L139.621 678.621L144 677L139.621 675.379L138 671L136.379 675.379L132 677L136.379 678.621L138 683Z",
    fill: "#F2F6FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 526L61.7958 519.431L68 517L61.7958 514.569L59.5 508L57.2042 514.569L51 517L57.2042 519.431L59.5 526Z",
    fill: "#F2F6FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M332 414L330.379 409.621L326 408L330.379 406.379L332 402L333.621 406.379L338 408L333.621 409.621L332 414Z",
    fill: "#F2F6FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M245 463L249.051 452.051L260 448L249.051 443.949L245 433L240.949 443.949L230 448L240.949 452.051L245 463Z",
    fill: "#F2F6FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeMobile);
export default __webpack_public_path__ + "static/media/welcome_mobile.e6501383a42d9dae62d002f3efcacaa6.svg";
export { ForwardRef as ReactComponent };